// extracted by mini-css-extract-plugin
export default {"howWorks":"HowWorks_howWorks__TkDrC","cards":"HowWorks_cards__+QvWt","card__SubTitle":"HowWorks_card__SubTitle__tyzK3","card__description":"HowWorks_card__description__1Gb51"};